import React from 'react';
import './About.css';

const SkillContainer = (props) => {
        return (
                <div className="d-inline-block ms-2 mt-2 skill-container">
                        {props.skill}
                </div>
        );
};

export default SkillContainer;